<template lang="">
  <div class="knowledge">
     <!-- 顶部banner -->
     <Banner title="知识库" description="与创新者同行，发现未来"/>
     <div class="knowledge_container">
      <div class="knowledge_content">
        <div class="brumb">
          <a href="javascript:void(0);">您当前的位置：</a><a href="/">主页 ></a><a
            href="javascript:void(0);">新闻资讯</a>
        </div>
        <div class="content">
          <div class="city_view">
            <div class="l">
              <div class="menu">
                <div class="tab">
                  <router-link :class="{active:currentIndex==item.id}" :to="{path:'/knowledge',query:{category_id:item.id}}"
                    v-for="(item,index) in knowledgecategoryList" :key="index">
                    {{item.title}}
                  </router-link>
                </div>
              </div>
            </div>
            <div id="site_demo" class="r">
              <div class="search_kuang">
                <el-input @keyup.enter.native="getknowledge" v-model="title" placeholder="请输入内容">
                </el-input>
                <i @click="getknowledge" class="el-icon-search"></i>
              </div>
              <ul>
                <li v-for="(item,index) in newList" :key="index">
                  <a href="javascript:void(0);" @click="openDialog(item.id)">
                    <div class="l">
                      <!-- <div class="number"></div> -->
                      <div class="title twoline">{{item.title}}</div>
                    </div>
                    <div class="r">
                      <div class="time">{{item.create_time}}</div>
                    </div>
                  </a>
                </li>
              </ul>
              <div id="pagination"></div>
            </div>
          </div>
          <pagination v-model="pageData" @event="getknowledge" />
        </div>
      </div>
     </div>
     <Knowledge ref="knowledge" :detailList="detail" />
  </div>
</template>
<script>
  import Knowledge from '@/components/knowledgeDialog.vue';
  import Banner from '@/components/inbanner'
  import pagination from '@/components/pagination'
  export default {
    components:{
      Banner,
      pagination,
      Knowledge
    },
    data() {
      return {
        knowledgecategoryList: [],
          currentIndex: 1,
          newList: [],
          pageData: {},
          category_id: 1,
          title:'',
          detail:{},
      }
    },
    watch:{
      '$route.query.category_id'(newVal, oldVal) {
          this.currentIndex = newVal
          this.category_id=newVal
          this.getknowledge()
        }
    },
    created() {
        this.getCategory()
        this.getknowledge()
      },
    // computed:{
    //   newDetail(){
    //     return this.detail
    //   }
    // },
    methods: {
      openDialog(id) {
        this.$refs.knowledge.dialogVisible = true;
        this.getDetail(id)
      },
        async getCategory() {
          const res = await this.$request.post('knowledgecategory/getAll')
          if (res.data.code === 0) {
            this.knowledgecategoryList = res.data.data
          }
        },
        async getknowledge(reload = true) {
          const res = await this.$request.post('knowledge/getPaginate', {
            fil:1,
            title:this.title?this.title:'',
            category_id: this.category_id,
            page: reload ? 1 : this.pageData.current_page
          })
          if (res.data.code === 0) {
            this.pageData = res.data.data
            this.newList = res.data.data.data
            this.title=''
          }
        },
        async getDetail(id){
          const res = await this.$request.post('knowledge/getDetail',{
            id:id
          })
          if (res.data.code===0) {
            this.detail=res.data.data
            console.log('我是细节',this.detail);
          }
        }
      },
  }
  </script>
  <style lang="">
    
  </style>